import { deepCopy, l, logEvent } from '@utils/toolbox';
import { eventCategories, events } from '@js/utils/event';
import { Base64 } from '@js/plugins/base64';
import { Dialog } from '@js/components/dialog';
import { computed } from 'vue';
import { startSearch } from '@js/utils/flightSearch';
import { useFiltersStore } from '../components/Filters/store/filtersStore';

const isCurrentSearchEconomy = js_params?.classType === 0;
const filtersStore = useFiltersStore();

const ticketTypes = computed(() => [
	{
		key: 0,
		index: 0,
		text: l('searchBox.ticketType.economy')
	},
	{
		key: 3,
		index: 1,
		text: l('searchBox.ticketType.premium')
	},
	{
		key: 1,
		index: 2,
		text: l('searchBox.ticketType.business')
	},
	{
		key: 2,
		index: 3,
		text: l('searchBox.ticketType.firstClass')
	}
]);

function getSelectedIndex (selectedTypes) {
	if (!selectedTypes?.length) {
		return null;
	}

	const indices = selectedTypes
		.map(type => ticketTypes.value.findIndex(t => t.key === type))
		.filter(i => i !== -1);

	return indices.length ? Math.min(...indices) : null;
}

function getTicketTypesFromIndex (index) {
	return ticketTypes.value.slice(index).map(t => t.key);
}

const selectedIndex = computed(() => {
	return getSelectedIndex(filtersStore.state.ticketType) ?? 0;
});

function isChecked (index) {
	return index >= selectedIndex.value;
}

function onButtonClick (index) {
	// if no filter or clicked button is the same as the active item, do nothing
	if (index === selectedIndex.value) {
		return;
	}

	if (isCurrentSearchEconomy && index === 0) {
		return;
	}

	const type = ticketTypes.value[index];

	if (isCurrentSearchEconomy && type.key !== 0) {
		onFetchClick(index);
		return;
	}

	filtersStore.set({
		key: 'ticketType',
		value: getTicketTypesFromIndex(index)
	});
}

async function onFetchClick (index) {
	await logEvent(events.filterTicketTypeModalOpened, eventCategories.filter);

	const dialog = new Dialog(
		l('showresult.filter.changeTicketType.title'),
		l('showresult.filter.changeTicketType.message')
	);

	const response = await dialog.show();

	if (response === 'cancel') {
		await logEvent(events.filterTicketTypeModalCanceled, eventCategories.filter);
		return;
	}

	await logEvent(events.filterTicketTypeModalConfirmed, eventCategories.filter);

	const searchBoxDataCopy = deepCopy(window.searchBox.getSearchDataForApi());
	searchBoxDataCopy.cabin = ticketTypes.value[index].key;
	searchBoxDataCopy.classType = ticketTypes.value[index].key;

	const resp = await startSearch(searchBoxDataCopy).catch(() => {
		new Dialog(
			l('error.e14'),
			''
		).show();
	});

	if (resp?.results?.id) {
		const filters = { ...filtersStore.get.value };

		await logEvent(events.filterTicketTypeEnabled, eventCategories.filter, ticketTypes.value[index].text);

		filters.ticketType = getTicketTypesFromIndex(index);

		window.location.href = `${window.location.pathname}?id=${resp.results.id}&filter=${Base64.encode(JSON.stringify(filters))}`;
	}
}

export function useTicketTypeFilter () {
	return {
		ticketTypes,
		selectedIndex,
		isChecked,
		onButtonClick,
		onFetchClick,
		isCurrentSearchEconomy,
		getTicketTypesFromIndex
	};
}
